import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { getValueByPath } from 'helpers/utils';
import { Form } from 'react-bootstrap';
import { InputProps, Props } from './textarea.type';

const InputField = ({ field, form, icon, ...props }: InputProps) => {
  const isError = Boolean(
    getValueByPath(form.errors, field.name) &&
      getValueByPath(form.touched, field.name)
  );

  return (
    <>
      <Form.Control
        {...field}
        {...props}
        isInvalid={isError}
        as="textarea"
        rows={3}
      />
      {icon && icon}
    </>
  );
};

export default function Textarea(props: Props) {
  return (
    <>
      <Field {...props} component={InputField} />
      <ErrorMessage
        name={props.name}
        component="div"
        className="invalid-feedback"
      />
    </>
  );
}
